import Vue from 'vue';
export default {
  data() {
    return {
      searchTitle: '',
      searchModal: false,
      isSearch: false,
      tableHeader: [
        { text: 'ردیف', value: 'counter', align: 'center' },
        {
          text: 'شماره تماس',
          value: 'phoneNumber',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'تاریخ ارسال',
          value: 'date',
          align: 'center',
          isGroupable: true,
        },
        {
          text: 'پیام دریافتی',
          value: 'message',
          align: 'center',
          isGroupable: true,
        },
        { text: 'وضعیت', value: 'status', align: 'center' },
      ],
      tableItems: [],
      searchFromDate: '',
      searchToDate: '',
      searchMissionId: null,
      searchSurveyCategoryId: null,
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
    };
  },
  methods: {
    makeDataReady: function (data) {
      this.tableItems = [];
      for (let i = 0; i < data.length; i++) {
        let date = '-';
        if (data[i].creationDate) {
          date = Vue.moment(data[i].creationDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.tableItems.push({
          counter: i + 1,
          phoneNumber: data[i].phoneNumber ? data[i].phoneNumber : '-',
          date: date,
          message: data[i].messageContent ? data[i].messageContent : '-',
          status: data[i].missionId ? data[i].missionId : null,
          missionId: data[i].missionId,
        });
      }
    },
    setPreTimes: function () {
      this.tempSearchFromDate = '00:00:00 ';
      let temp = Vue.moment().format('jYYYY-jMM-jDD');
      this.tempSearchFromDate += temp;
      this.searchFromDate = Vue.moment().format('YYYY-MM-DD');
      this.searchFromDate += 'T00:00:00';
      this.searchToDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.tempSearchToDate = Vue.moment().format('HH:mm:ss jYYYY-jMM-jDD');
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.searchModal = true;
    },
    search: function () {
      this.page = 1;
      this.searchModal = false;
      this.isSearch = true;
      this.$refs.pagination.page = 1;
      this.getQCSurveyReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchMissionId,
        this.searchSurveyCategoryId,
        this.page,
        this.pageSize,
      );
    },
    removeFilters: function () {
      this.searchMissionId = null;
      this.searchSurveyCategoryId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.isSearch = false;
      this.page = 1;
      this.$refs.pagination.page = 1;
      this.getQCSurveyReportFunction(
        this.searchFromDate,
        this.searchToDate,
        this.searchMissionId,
        this.searchSurveyCategoryId,
        this.page,
        this.pageSize,
      );
    },
    cancelSearch: function () {
      this.searchMissionId = null;
      this.searchSurveyCategoryId = null;
      this.searchFromDate = '';
      this.searchToDate = '';
      this.tempSearchFromDate = '';
      this.showSearchFromDate = false;
      this.tempSearchToDate = '';
      this.showSearchToDate = false;
      this.searchModal = false;
    },
    goToReportPage: function (row) {
      if (row?.status)
        this.$router.replace({
          name: 'missionReport',
          query: { missionId: row?.status },
        });
      else this.showErrorAlert('برای این پرونده ماموریت ثبت نشده!');
    },
  },
  computed: {
    excelTableData: function () {
      return [...this.tableItems].map(({ missionId, ...rest }) => {
        const statusTxt = missionId > 0 ? 'دارای پرونده' : 'فاقد پرونده';
        return {
          ...rest,
          status: statusTxt,
        };
      });
    },
  },
};
